export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 2L10.5 5.75L14.25 9.5L17.25 6.5H19.125V11H3.375V18.875H8.89872L8.04883 19.8949C7.78366 20.2131 7.82665 20.686 8.14486 20.9512C8.46307 21.2163 8.93599 21.1733 9.20117 20.8551L11.4763 18.125L9.20117 15.3949C8.93599 15.0767 8.46307 15.0337 8.14486 15.2988C7.82665 15.564 7.78366 16.0369 8.04883 16.3551L8.89872 17.375H4.875V12.5H20.625V5H17.25L14.25 2ZM14.25 7.37868L12.6213 5.75L14.25 4.12132L15.8787 5.75L14.25 7.37868Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 2.75C3.67157 2.75 3 3.42157 3 4.25V7.25C3 8.07843 3.67157 8.75 4.5 8.75H7.5C8.32843 8.75 9 8.07843 9 7.25V4.25C9 3.42157 8.32843 2.75 7.5 2.75H4.5ZM7.5 4.25H4.5V7.25H7.5V4.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 14.75C13.4216 14.75 12.75 15.4216 12.75 16.25V19.25C12.75 20.0784 13.4216 20.75 14.25 20.75H19.5C20.3284 20.75 21 20.0784 21 19.25V16.25C21 15.4216 20.3284 14.75 19.5 14.75H14.25ZM14.25 16.25V19.25H19.5V16.25H14.25Z"
      fill="currentColor"
    />
  </>
);
